import {EventBus} from "../../../common/ts/events/EventBus";
import tracking from "../../../common/ts/core/tracking";
import {SECTION_CLICKED_EVENT_TYPE} from "../../../common/ts/tracking/constants";

function init() {
    registerHorizontalNavigationChipsClick();
    registerRemoveKeywordPartsChipsClick();
}

function registerHorizontalNavigationChipsClick() {
    document.querySelectorAll("#property-type-suggestions > a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => handleClick(element as HTMLElement));
    });

    document.querySelectorAll("#nearby-location-suggestions > a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => handleClick(element as HTMLElement));
    });

    document.querySelectorAll("#operation-type-suggestions > a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => handleClick(element as HTMLElement));
    });
}

function registerRemoveKeywordPartsChipsClick() {
    document.querySelectorAll("#remove-keyword-parts a").forEach((element) => {
        (element as HTMLElement).addEventListener('click', () => handleClick(element as HTMLElement));
    });
}

function handleClick(chip: HTMLElement) {
    const name = chip.dataset.name;
    const section = chip.dataset.section;

    if (!name || !section) return;

    EventBus.getInstance().emit(new tracking.TrackAmplitudeEvent({
        type: SECTION_CLICKED_EVENT_TYPE,
        serpUrl: window.location.href,
        sectionName: name,
        value: chip.innerText,
        section: section,
    }));
}

export default {
    init,
};